import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const CertsUploadedModal = ({
  show,
  onHide,
  value = "",
  onSave,
  shouldUpdateProfile = false,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  const certOptions = [
    { value: "true", label: "Yes, certifications uploaded" },
    { value: "false", label: "No certifications uploaded" },
  ];

  // Load existing value
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSelectedOption(
        value !== undefined && value !== null ? String(value) : "",
      );
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.certs_uploaded;

      setSelectedOption(
        current !== undefined && current !== null ? String(current) : "",
      );
    }
  }, [show, value, isApplyPage, store]);
  // useEffect(() => {
  //   if (!show) return;

  //   if (isApplyPage) {
  //     setSelectedOption(value !== undefined ? String(value) : "");
  //   } else {
  //     const current = store?.profileItem?.data?.nurseProfile?.certs_uploaded;

  //     if (current !== undefined && current !== null) {
  //       setSelectedOption(String(current));
  //     }
  //   }
  // }, [show, value, isApplyPage]);

  // const handleSelect = (value) => {
  //   setSelectedOption(value);
  //   setError("");
  // };
  const handleSelect = (val) => {
    setSelectedOption(val);
    setError("");

    // 🔥 LIVE SYNC (optional like salary)
    if (isApplyPage && onSave) {
      onSave(val === "true");
    }
  };
  const handleSave = () => {
    if (selectedOption === "") {
      setError("Please select an option");
      return;
    }

    const finalValue = selectedOption === "true";

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(finalValue);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("certs_uploaded", finalValue);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("certs_uploaded", finalValue);

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select an option");
  //     return;
  //   }

  //   const finalValue = selectedOption === "true";

  //   if (isApplyPage) {
  //     // ✅ LOCAL
  //     onSave(finalValue);
  //     onHide();
  //   } else {
  //     // ✅ API
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         ""
  //     );

  //     formData.append("certs_uploaded", finalValue);

  //     dispatch(updateProfile(formData));
  //   }
  // };

  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Have you uploaded your certifications?</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {certOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedOption === ""}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CertsUploadedModal;
